import { useEffect } from "react";
import { sessionState, useChatSession } from "@chainlit/react-client";
// import { Playground } from "./components/playground";
import { useRecoilValue } from "recoil";
import ChatbotWidget from './ChatbotWidget';

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import DashboardPage from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
const userEnv = {};
const CHAINLIT_SERVER = process.env.REACT_APP_CHAINLIT_URL || "https://weschatbotbe.codewebs.in";
function App() {
  const { connect } = useChatSession();
  console.log("Connecting to Chainlit server:", CHAINLIT_SERVER);
  const session = useRecoilValue(sessionState);
  useEffect(() => {
    if (session?.socket.connected) {
      return;
    }
    fetch(`${CHAINLIT_SERVER}/custom-auth`, { credentials: "include" })
      .then(() => {
        connect({
          userEnv
        });
      });
  }, [connect]);
  return (

    <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              // <ProtectedRoute>
                <HomePage />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
                <div className="h-screen">
                  <ChatbotWidget />
                </div>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <div className="h-screen">
                  <DashboardPage />
                </div>
              </ProtectedRoute>
                
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </Router>
    // <>
    //   <div>
    //     <ChatbotWidget />
    //   </div>
    // </>
  );
}
export default App;

